import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

export interface User {
    ID: string
    email: string
    companyID: string
    token?: string
    tokenExpire?: number
}

export interface Company {
    ID: string
    logo: string
    name: string
}

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    private apiURL = `${GlobalConstants.apiURL}`; // /survey
    userSubject: BehaviorSubject<User | null> = new BehaviorSubject<User | null>(null);

    companySubject: BehaviorSubject<Company | null> = new BehaviorSubject<Company | null>(null);
    companyLoaded = false;

    constructor(
        private http: HttpClient,
    ) {
        const user: User | null = JSON.parse(localStorage.getItem('user') || 'null');
        if (user) {
            this.userSubject.next(user);
        }
    }


    getCompany(): BehaviorSubject<Company | null> {
        if (!this.companyLoaded) this.callGetCompanyAPI();
        this.companyLoaded = true;
        return this.companySubject;
    }

    private callGetCompanyAPI() {
        const url = this.apiURL + '/company';
        this.http.get<Company | null>(url, {
            responseType: 'json'
        }).subscribe({
            next: (res: any) => {
                const data: Company | null = res.payload;
                this.companySubject.next(data);
            },
            error: () => {
                this.companySubject.next(null);
            }
        });
    }


    login(params: { email: string, password: string }) {

        localStorage.removeItem('user');
        const url = `${this.apiURL}/jwt/login`;

        return new Observable(observer => {
            this.http.post<any>(url, params, {
                responseType: 'json'
            }).subscribe({
                next: (res: any) => {
                    const data = res.payload;
                    localStorage.setItem('user', JSON.stringify(data));
                    this.userSubject.next(data);
                    observer.next(data);
                },
                error: () => {
                    this.userSubject.next(null);
                    observer.next(null);
                }
            });
        });
    }

}
